"use strict";

var _ExceptionCode = require("./ExceptionCode");

/**
 * Classe de exceção padrão do Easy Delivery
 */
class Exception extends Error {
  get code() {
    return this._code;
  }

  get message() {
    return this._message;
  }

  get options() {
    return this._options;
  }

  constructor(code = 0, message = null, options = null) {
    if (!message) {
      message = _ExceptionCode.ExceptionCode.getMessage(code, process.env.LANGUAGE || 'en_en');
    }

    super(message);
    this._code = code;
    this._message = message;
    this._options = options;
  }

}

exports.Exception = Exception;